import React from "react";

export const XLogo = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-testid="xyloctra-logo-mark"
  >
    <defs>
      <linearGradient id="xg1" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00E5FF" />
        <stop offset="1" stopColor="#0052FF" />
      </linearGradient>
      <linearGradient id="xg2" x1="40" y1="0" x2="0" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7C3AED" />
        <stop offset="1" stopColor="#00E5FF" />
      </linearGradient>
    </defs>
    <rect x="0.5" y="0.5" width="39" height="39" rx="9" stroke="rgba(255,255,255,0.08)" />
    <path d="M9 9 L20 20 L31 9" stroke="url(#xg1)" strokeWidth="2.6" strokeLinecap="square" />
    <path d="M9 31 L20 20 L31 31" stroke="url(#xg2)" strokeWidth="2.6" strokeLinecap="square" />
    <circle cx="20" cy="20" r="1.8" fill="#00E5FF" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="xyloctra-wordmark">
    <XLogo size={26} />
    <div className="leading-none">
      <div className="font-heading font-bold tracking-tight text-white text-[17px]">Xyloctra</div>
      <div className="tech-label mt-0.5 text-[9px]">ENTERPRISE INTELLIGENCE</div>
    </div>
  </div>
);

export default Wordmark;
